module.exports = __webpack_public_path__ + "static/media/o.c83fe879.png";